import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';
import { prepareSearchParams } from '@/libs/helper';

const resource = `${Config.basePath}/v1/api/admin/transaction/request`;

export default {
  index(payload) {
    let params = prepareSearchParams(payload);
    params = {
      ...payload,
      ...params,
      username: payload.search,
    }
    if (payload.startDate) {
      params.filters.push({
        searchby: "created_at",
        searchoperator: ">",
        search: `${payload.startDate} 00:00:00`,
      });
    }
    if (payload.endDate) {
      params.filters.push({
        searchby: "created_at",
        searchoperator: "<",
        search: `${payload.endDate} 23:59:59`,
      });
    }
    return Client.post(`${resource}/deposit`, params, {
      headers: {
        action: "list-deposit-request",
      },
    });
  },
  total(payload) {
    let params = prepareSearchParams(payload);
    params = {
      ...payload,
      ...params,
      username: payload.search,
    }
    if (payload.startDate) {
      params.filters.push({
        searchby: "created_at",
        searchoperator: ">",
        search: `${payload.startDate} 00:00:00`,
      });
    }
    if (payload.endDate) {
      params.filters.push({
        searchby: "created_at",
        searchoperator: "<",
        search: `${payload.endDate} 23:59:59`,
      });
    }
    return Client.post(`${resource}/deposit`, params, {
      headers: {
        action: "total-deposit-request",
      },
    });
  },
  update(payload) {
    return Client.post(`${resource}`, payload, {
      headers: {
        action: "update-request-status",
      },
    });
  },
};
